import { AdminTeamDTO } from "@shaarp/common";
import { DataTable } from "../data-table/data-table";
import { dataTableAdminTeamsColumns } from "./data-table-admin-teams-columns";

export default function DataTableAdminTeams({
  teams,
  isLoading,
  toolbarContent,
  emptyText,
}: {
  teams: AdminTeamDTO[];
  isLoading: boolean;
  toolbarContent?: React.ReactNode;
  emptyText?: string;
}) {
  return (
    <DataTable
      data={teams}
      columns={dataTableAdminTeamsColumns()}
      columnsPersistenceKey="data-table-admin-teams"
      isLoading={isLoading}
      sortingState={[
        { id: "Activé", desc: true },
        { id: "Date de création", desc: true },
      ]}
      toolbarContent={toolbarContent}
      emptyText={emptyText}
      stickyColumns={2}
    />
  );
}
